export default __webpack_public_path__ + "static/media/illustration_gamer-insights@2x.7840c77c.png";